
class SalesOrderDeliveryManager {

    constructor(_skipWeekends = true) {
        
        this.skipWeekends = _skipWeekends;
    }

    calculateExpectedDeliveryDate(_orderData) {

        var baseDateTime = _orderData && _orderData.hasOwnProperty("TrasnactionDate") ? new Date(_orderData.TransactionDate) : new Date(Date.now());
        var deliveryDateRequested = null;
        
        if (_orderData) {
            if (_orderData.hasOwnProperty("DeliveryDateRequested")) {
                deliveryDateRequested = new Date(_orderData.DeliveryDateRequested);
            }
            else if (_orderData.hasOwnProperty("DeliveryDate")) {
                deliveryDateRequested = new Date(_orderData.DeliveryDate);
            }
        }

        var daysAhead = 0;

        // Orders placed before 15:00 are dispatched the next day. Orders placed after 15:00 are delivered 2 days after
        if (baseDateTime.getHours() > 15 || (baseDateTime.getHours() == 15 &&  baseDateTime.getMinutes() > 0)) {
            daysAhead = 2;
        }
        else {
            daysAhead = 1;
        }

        baseDateTime.setDate(baseDateTime.getDate() + daysAhead);

        // Skip sundays
        while (this.skipWeekends && baseDateTime.getDay() === 0)
            baseDateTime.setDate(baseDateTime.getDate() + 1);

        if (deliveryDateRequested && deliveryDateRequested > baseDateTime) {
            return deliveryDateRequested;
        }
        else {
            return baseDateTime;
        }
    }
}


export default SalesOrderDeliveryManager;